import router from 'router';

function getAccountingCodes(params, data) {
    return window.ApiClient.post(
        router.resolve({ name: 'accounting.code.search', params: { id: params.id } }).href,
        params,
        data
    )
}

function getAllAccountingCodes(params, data) {
    const codes = [];
    let pagination;

    const fetchCodes = async function (offset) {
        const response = await getAccountingCodes(offset ? { ...params, offset } : params, data);

        response.data.data.forEach(code => codes.push(code));
        pagination = response.data.pagination;

        if (pagination.count === pagination.limit) {
            return await fetchCodes(pagination.offset);
        }
        return codes;
    }

    return new Promise(async (resolve, reject) => {
        let allRows;
        await fetchCodes(null).then(function (rows) {
            allRows = rows;
        }).catch(reject);

        resolve(allRows);
    })
}

function getAllTaxes() {
    return window.ApiClient.get(router.resolve({ name: 'accounting.taxes.all' }).href)
};

function getTaxes(params, data) {
    return window.ApiClient.post(
        router.resolve({ name: 'accounting.taxes.search' }).href,
        params,
        data
    )
}

function getDefaultAccountingPurchaseCode() {
    return new Promise((resolve, reject) => {
        window.SellsyJS.WebServiceCaller.get(
            router.resolve({ name: 'legacy.accounting.default.code.purchase' }).href,
            {},
            response => {
                resolve(response);
            }, err => {
                reject(err.response.data.error.message);
            }
        )
    })
}

function setAutomaticAccountingRecordPrefs(data, id) {
    return new Promise((resolve, reject) => {
        window.SellsyJS.WebServiceCaller.put(
            router.resolve({ name: 'legacy.accounting.automatic.recording', params: { 'id': id }  }).href,
            {},
            data,
            response => {
                resolve(response);
            }, err => {
                reject(err.response.data.error.message);
            }
        )
    })
}

export default {
    getAccountingCodes,
    getAllAccountingCodes,
    getAllTaxes,
    getTaxes,
    getDefaultAccountingPurchaseCode,
    setAutomaticAccountingRecordPrefs
}